<template>
  <div class="footer">
    <div class="hd__container">
      <div class="footer__copyright">
        Copyright© 上海金字塔实业发展有限公司版权所有{{ themeName=='green'?'www.metawit.com':'www.partnerone.cn' }} 
        <!-- <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32098202000188"
          >苏公网安备 32098202000188号</a
        > -->
        <a href="https://beian.miit.gov.cn/">沪ICP备2024093039号-1</a>
        山东河姆渡工业互联网有限公司提供技术服务
      </div>
      <!--      <div class="footer__flag">-->
      <!--        <a ref="nofollow" href="http://zwdt.sh.gov.cn/govPortals/organ_index.do?organ=SHGSSH">-->
      <!--          <img src="../../assets/images/flag1.png" />-->
      <!--        </a>-->
      <!--        <a ref="nofollow" href="http://www.zx110.org/?tp=1.1.20.0.22.LDPMs0Z-11-EVbUx&ti=YF3N">-->
      <!--          <img src="../../assets/images/flag2.png" />-->
      <!--        </a>-->
      <!--        <a-->
      <!--          ref="nofollow"-->
      <!--          href="https://ss.knet.cn/verifyseal.dll?sn=e15112531011561585wvnw000000&ct=df&a=1&pa=0.0870537762530148"-->
      <!--        >-->
      <!--          <img src="../../assets/images/flag3.png" />-->
      <!--        </a>-->
      <!--        <a ref="nofollow" href="https://credit.szfw.org/CX20151119012313570179.html">-->
      <!--          <img src="../../assets/images/flag4.gif" />-->
      <!--        </a>-->
      <!--      </div>-->
    </div>
  </div>
</template>

<script>
import { computed, defineComponent } from "vue";
import store from "@/store";
export default defineComponent({
  isGlobal: true,
  name: "HmdFooter",
  setup(props) {
    const themeName = computed(() => store.state.theme.themeName);
    return {
      themeName,
    };
  },
});
</script>

<style lang="less">
@import "./index";
</style>
